import { saveAs } from 'file-saver'

function markdownFilename(name: string): string {
  const filename = name
    .trim()
    .replace(/[<>:"/\\|?*]/gu, '-')
    .replace(/\s+/gu, ' ')
    .replace(/[. ]+$/u, '')
  return `${filename || 'skill'}.md`
}

export function downloadSkillMarkdown(name: string, description: string): void {
  saveAs(new Blob([description], { type: 'text/markdown;charset=utf-8' }), markdownFilename(name))
}
